/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { isFunction } from 'lodash';

// Components
import BulkForm from 'shared/ui/components/form-components/bulk-editing/BulkForm.vue';
import LoaderButton from 'shared/ui/components/form-components/LoaderButton.vue';

const __vue_script__ = {
    name: 'BulkEditor',

    components: { BulkForm, LoaderButton },

    props: {
        event: {
            type: Object,
            required: true
        },

        context: {
            type: Object,
            default: () => null
        },

        fpType: {
            type: String,
            required: true
        },

        items: {
            type: Array,
            default: () => []
        },

        title: {
            type: String,
            default: null
        },

        introText: {
            type: String,
            default: null
        },

        submitLabel: {
            type: String,
            default: 'general.edit'
        },

        onSuccess: {
            type: Function,
            default: null
        }
    },

    data() {
        return {
            progress: 0,
            submitting: false
        };
    },

    methods: {
        async submit(form) {
            try {
                if (this.submitting) {
                    return;
                }

                this.submitting = true;

                const { changes, options, ids } = form;
                const { jobId } = await this.$services.documents.bulkEditDocs(this.event._id, this.fpType, changes, options, ids);
                await this.$services.jobs.waitFor({
                    jobId,
                    updateUIProgress: (p) => this.progress = p
                });

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('listings.editing.bulk_updated', [this.items.length]).toString(),
                    type: 'success',
                    duration: 5000
                });

                if (isFunction(this.onSuccess)) {
                    await this.onSuccess();
                }

                this.$emit('close');
            } catch (error) {
                if (error.error) {
                    console.error('[BulkEditor] BE returned an error', error.error);
                } else {
                    console.error('[BulkEditor] Could not complete the editing', error.message || error);
                }

                this.$notify({
                    group: 'flashes',
                    title: this.$t('general.error_occurred'),
                    text: this.$i18n.t('listings.editing.bulk_update_failed').toString(),
                    type: 'error',
                    duration: 5000
                });
            } finally {
                this.submitting = false;
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bulk-editor modal-wrapper"},[_c('div',{staticClass:"modal-header"},[_c('span',{staticClass:"close",on:{"click":function($event){return _vm.$emit('close')}}}),(_vm.title)?_c('h3',[_vm._v(_vm._s(_vm.title))]):_vm._e()]),_c('div',{staticClass:"modal-body"},[(_vm.submitting)?[_c('p',[_vm._v(_vm._s(_vm.$tc('listings.editing.bulk_updating', _vm.items.length, [_vm.items.length] )))]),_c('progress-bar',{attrs:{"progress":_vm.progress}})]:[(_vm.introText)?_c('i18n',{attrs:{"tag":"p","path":_vm.introText}},[_c('strong',[_vm._v(_vm._s(_vm.items.length))])]):_vm._e(),_c('div',{staticClass:"alert alert-warning"},[_c('p',[_vm._v(_vm._s(_vm.$t('listings.messages.bulk_edit')))]),_c('i18n',{attrs:{"tag":"p","path":"listings.messages.bulk_edit_2"}},[_c('strong',[_vm._v("*")])])],1),_c('bulk-form',{ref:"form",attrs:{"event":_vm.event,"items":_vm.items,"fp-type":_vm.fpType,"disabled":_vm.submitting},on:{"submit":_vm.submit}})]],2),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn",attrs:{"type":"button","disabled":_vm.submitting},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v(_vm._s(_vm.$t('general.cancel')))]),_c('loader-button',{staticClass:"btn-primary",attrs:{"status":_vm.submitting},on:{"click":function($event){return _vm.$refs.form.submit()}}},[_vm._v(_vm._s(_vm.$tc(_vm.submitLabel, _vm.items.length, [_vm.items.length])))])],1)])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "BulkEditor.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__